import {Button, Col, Row, Typography} from "antd";
import {momentOrNull} from "common/util";
import './header.style.less'
import moment, { isMoment } from "moment";
import {ComplianceTicketFormData} from "../types";
import React from "react";
import {VeriflytTicketEditorApi} from "../veriflyt-ticket-editor";
import {useTicketTemplate} from "../graphql";
import useBreakpoints from "../../../../hooks/useBreakpoints";

export interface ComplianceHeaderProps {
    data: ComplianceTicketFormData,
    api: VeriflytTicketEditorApi,
    compact?: boolean
}

const BASE_CLS = 'compliance-header';

const VeriflytTicketEditorHeader: React.FC<ComplianceHeaderProps> = ({ data, api, compact }) => {
    const bp = useBreakpoints();

    const { ticketTemplate } = useTicketTemplate(data.ticketTemplateIDAndName?.value?.key);

    const isNew = !data._id;

    const nextDate = momentOrNull(data?.expirationDate?.value);
    const lastDate = momentOrNull(data?.completionDate?.value);

    let status: React.ReactNode = '';
    const hasPassed = data?.result_passed?.value === 1;

    const statusClassName = "compliance-header-status";

    if (isMoment(nextDate) && moment().isAfter(nextDate)){
        status = <Typography.Text className={statusClassName} type="danger">EXPIRED</Typography.Text>
    }
    else if ((!data._id || hasPassed) && isMoment(nextDate) && moment().add(1, 'month').isAfter(nextDate)){
        status = <Typography.Text className={statusClassName} type="warning">EXPIRES SOON</Typography.Text>
    }
    else if (!hasPassed && data?._id){
        status = <Typography.Text className={statusClassName} type="danger">FAILED</Typography.Text>
    }
    else if (isMoment(nextDate)) {
        status = <Typography.Text className={statusClassName} style={{ color: 'green' }}>
            VALID
        </Typography.Text>
    }

    status = status ? <span>{status}</span> : status;

    const ticketTemplateName = ticketTemplate?.onScreenName || '';

    const gutterSize = ticketTemplateName ? 24 : 12;

    return (
        <>
            <Row type="flex" align="middle" gutter={gutterSize} className="compliance-header">
                {ticketTemplateName ? (
                    <>
                        <Col className={BASE_CLS + '-name-column'} title={ticketTemplateName}>{ticketTemplateName}</Col>
                        <Col className={BASE_CLS + '-originator-column'}>
                            {data.ticketTemplateDoc?.originatorDoc?.primaryName}
                        </Col>
                    </>
                ) : (
                    <Col>New Record</Col>
                )}
                {isNew ? (
                    <Col className={BASE_CLS + '-unsaved-column'}><Typography.Text type="warning">(Unsaved)</Typography.Text></Col>
                ) : null}
                {lastDate && !compact ? (
                    <Col className={BASE_CLS + '-lastdate-column'}>
                        <Typography.Text type="secondary">
                            Completion date:
                        </Typography.Text>{' '}
                        {lastDate?.format('YYYY-MM-DD')}
                    </Col>
                ) : null}
                {nextDate && !compact ? (
                    <Col className={BASE_CLS + '-nextdate-column'}>
                        <Typography.Text type="secondary">
                            {bp.max('medium') ?
                            'Exp:' : 'Expiration date:'}
                        </Typography.Text>{' '}
                        {nextDate?.format('YYYY-MM-DD')}
                    </Col>
                ) : null}
                <Col className={BASE_CLS + '-status-column'}>
                    {status}
                </Col>
                {!api.readOnly ? (
                    <Col className={BASE_CLS + '-delete-column'}>
                        <Button
                            type="danger"
                            ghost
                            icon="delete"
                            size="small"
                            onClick={() => api.removeTicket(data)}
                        />
                    </Col>
                ) : null}
            </Row>
        </>

    )
}

export default VeriflytTicketEditorHeader